export default function notificationDirective(NotificationService, $timeout, utils) {
	"ngInject";

	return {
		restrict: "E",
		templateUrl: "./components/notification/notification-template.html",
		replace: true,
		scope: {},
		link: (scope) => {
			scope.notifications = [];

			NotificationService.listen((notification) => {
				scope.notifications.push(notification);

				if (notification.type !== NotificationService.type.ERROR) {
					// dismiss non-error notification after 5s
					$timeout(() => {
						scope.dismiss(notification);
					}, 5000);
				} else {
					// dismiss old error notifications that are the same
					$timeout(() => {
						scope.notifications
							.filter((current) => (current.type === NotificationService.type.ERROR && current !== notification && current.message === notification.message))
							.forEach(scope.dismiss);
					});

					// dismiss old error notification after 10s
					$timeout(() => {
						scope.notifications
							.filter((current) => (current.type === NotificationService.type.ERROR && current !== notification))
							.slice(0, -1)
							.forEach(scope.dismiss);
					}, 10000);
				}
			});


			scope.dismiss = (notification) => {
				utils.removeItem(notification, scope.notifications);
			};

			scope.getIcon = (notification) => {
				switch (notification.type) {
					case NotificationService.type.INFO:
						return "info";
					case NotificationService.type.SUCCESS:
						return "check-active";
					case NotificationService.type.WARNING:
						return "warning";
					case NotificationService.type.ERROR:
						return "warning";
				}
			};
		}
	};
}
